import { inject, Injectable, computed, Injector } from '@angular/core';
import { Profile } from '@/app/core/services/profile';
import { mapToFrontendFormat } from '@/app/core/helpers/permission';
import { toObservable } from '@angular/core/rxjs-interop';
import { filter, take, map } from 'rxjs';

const DEFAULT_ROUTE_PERMISSIONS = [
  { path: '/dashboard', permission: 'Dashboard:canView' },
  { path: '/monitoring-panel2', permission: 'RealTimeMonitoringDashboard:canView' },
  { path: '/alarm-log', permission: 'AlarmManagement:canView' },
  { path: '/device-management', permission: 'DeviceManagement:canView' },
  { path: '/maintenance-management', permission: 'MaintenanceManagement:canView' },
  { path: '/system-management', permission: 'SystemManagement:canView' },
  { path: '/notification-management', permission: 'NotificationManagement:canView' },
];

@Injectable({
  providedIn: 'root',
})
export class Permission {
  private readonly injector = inject(Injector);
  private readonly profile = inject(Profile);

  readonly permissions = computed(() => {
    const permissions = this.profile.authProfile()?.role.permissions;

    return permissions ? mapToFrontendFormat(permissions) : [];
  });

  hasPermission(requiredPermission: string) {
    return this.permissions().includes(requiredPermission);
  }

  getDefaultUrl() {
    return toObservable(this.profile.authProfile, { injector: this.injector }).pipe(
      filter((profile): profile is NonNullable<typeof profile> => profile !== null),
      take(1),
      map(() => {
        const matched = DEFAULT_ROUTE_PERMISSIONS.find((item) =>
          this.hasPermission(item.permission),
        );
        return matched ? matched.path : '/not-found';
      }),
    );
  }
}
